module.exports = __webpack_public_path__ + "img/455.6a35a90b.png";